// extracted by mini-css-extract-plugin
var _1 = "ToolbarObjectButton-module__label--UgoN_";
var _2 = "ToolbarObjectButton-module__popOver--Q7htz";
export { _1 as "label", _2 as "popOver" }
